import React from 'react'
import { useTheme } from '../../../../Utils/useTheme'
import { FilterSpec } from '../types'
import { stableId } from '../utils/ids'

export const ActiveFiltersBar = ({
  filters,
  onRemove,
  onClear
}: {
  filters: FilterSpec[]
  onRemove: (key: string) => void
  onClear: () => void
}) => {
  const { border, text, hover } = useTheme()
  if (!filters || filters.length === 0) return null

  return (
    <div
      style={{
        display: 'flex',
        gap: 8,
        flexWrap: 'wrap',
        padding: '10px 12px',
        background: 'rgba(255,255,255,1)',
        borderBottom: `1px solid ${border}`
      }}
    >
      {filters.map((f) => (
        <div
          key={stableId('filter', `${f.key}:${f.op}:${String(f.value ?? '')}:${String(f.value2 ?? '')}`)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            padding: '6px 10px',
            borderRadius: 999,
            border: `1px solid ${border}`,
            background: 'rgba(17,24,39,0.06)',
            color: text,
            fontSize: 12,
            maxWidth: 420
          }}
        >
          <div style={{ fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.key}</div>
          <div style={{ opacity: 0.7 }}>{f.op}</div>
          {f.value !== undefined && <div style={{ opacity: 0.9, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{String(f.value)}</div>}
          {f.value2 !== undefined && <div style={{ opacity: 0.9, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{String(f.value2)}</div>}
          <div
            style={{ width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', borderRadius: 7, cursor: 'pointer' }}
            onMouseEnter={e => (e.currentTarget.style.background = hover)}
            onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
            onClick={() => onRemove(f.key)}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
              <path d="M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </div>
        </div>
      ))}

      <div style={{ flex: 1 }} />

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          padding: '6px 10px',
          borderRadius: 999,
          border: `1px solid ${border}`,
          background: 'white',
          color: text,
          fontSize: 12,
          cursor: 'pointer',
          userSelect: 'none'
        }}
        onMouseEnter={e => (e.currentTarget.style.background = hover)}
        onMouseLeave={e => (e.currentTarget.style.background = 'transparent')}
        onClick={onClear}
      >
        Clear
      </div>
    </div>
  )
}
